import store from '@/store'

//所有权限
const funcMap = {
  // 机构管理模块
  addAuthOrg: {
    funcCode: '001func0001',
    funcName: '添加机构表',
  },
  delAuthOrg: {
    funcCode: '001func0002',
    funcName: '删除机构表',
  },
  uptAuthOrg: {
    funcCode: '001func0003',
    funcName: '修改机构表',
  },
  qryAuthOrg: {
    funcCode: '001func0004',
    funcName: '查询机构表',
  },

  // 应用管理模块
  addAuthApp: {
    funcCode: '002func0001',
    funcName: '添加应用表',
  },
  delAuthApp: {
    funcCode: '002func0002',
    funcName: '删除应用表',
  },
  uptAuthApp: {
    funcCode: '002func0003',
    funcName: '修改应用表',
  },
  qryAuthApp: {
    funcCode: '002func0004',
    funcName: '查询应用表',
  },

//模块管理模块
  addAuthMod: {
    funcCode: '003func0001',
    funcName: '添加功能模块表',
  },

  delAuthMod: {
    funcCode: '003func0002',
    funcName: '删除功能模块表',
  },
  uptAuthMod: {
    funcCode: '003func0003',
    funcName: '修改功能模块表',
  },
  qryAuthMod: {
    funcCode: '003func0004',
    funcName: '查询功能模块表',
  },

//功能管理模块
  addAuthFunc: {
    funcCode: '004func0001',
    funcName: '添加功能表',
  },
  delAuthFunc: {
    funcCode: '004func0002',
    funcName: '删除功能表',
  },

  uptAuthFunc: {
    funcCode: '004func0003',
    funcName: '修改功能表',
  },
  qryAuthFunc: {
    funcCode: '004func0004',
    funcName: '查询功能表',
  },


//角色管理模块
  addAuthRole: {
    funcCode: "005func0001",
    funcName: "添加角色表",
  },
  delAuthRole: {
    funcCode: "005func0002",
    funcName: "删除角色表",
  },
  uptAuthRole: {
    funcCode: "005func0003",
    funcName: "修改角色表",
  },
  qryAuthRole: {
    funcCode: "005func0004",
    funcName: "查询角色表",
  },


//用户管理模块
  addAuthUser: {
    funcCode: "006func0001",
    funcName: "新增管理员用户",
  },
  delAuthUser: {
    funcCode: "006func0002",
    funcName: "删除管理员用户",
  },
  uptAuthUser: {
    funcCode: "006func0003",
    funcName: "修改管理员用户",
  },
  qryAuthUser: {
    funcCode: "006func0004",
    funcName: "查询管理员用户",
  },

//支付模块
  payRecords: {
    funcCode: "007func0001",
    funcName: "支付记录",
  },
  //充值模块
  recharge: {
    funcCode: "008func0001",
    funcName: "充值提现",
  },

//员工管理模块
  addEmployee: {
    funcCode: "009func0001",
    funcName: "添加员工",
  },
  delEmployee: {
    funcCode: "009func0002",
    funcName: "删除员工",
  },
  uptEmployee: {
    funcCode: "009func0003",
    funcName: "修改员工",
  },
  qryEmployee: {
    funcCode: "009func0004",
    funcName: "查询员工",
  },

  //员工类型
  addEmployeeType: {
    funcCode: "009func0005",
    funcName: "添加员工类型",
  },
  delEmployeeType: {
    funcCode: "009func0006",
    funcName: "删除员工类型",
  },
  uptEmployeeType: {
    funcCode: "009func0007",
    funcName: "修改员工类型",
  },
  qryEmployeeType: {
    funcCode: "009func0008",
    funcName: "查询员工类型",
  },

  //员工子类型
  addEmployeeSubType: {
    funcCode: "009func0009",
    funcName: "添加员工子类型",
  },
  delEmployeeSubType: {
    funcCode: "009func0010",
    funcName: "删除员工子类型",
  },
  uptEmployeeSubType: {
    funcCode: "009func0011",
    funcName: "修改员工子类型",
  },
  qryEmployeeSubType: {
    funcCode: "009func0012",
    funcName: "查询员工子类型",
  },

  //统计模块
  departSaleCount: {
    funcCode: "010func0001",
    funcName: "部门消费汇总",
  },
  offline: {
    funcCode: "010func0002",
    funcName: "脱机欠费查询",
  },

  //报表模块
  canteenSaleSet: {
    funcCode: "011func0001",
    funcName: "食堂自费结算",
  },
  stallSaleSet: {
    funcCode: "011func0002",
    funcName: "档口自费结算",
  },
  centerSySet: {
    funcCode: "011func0003",
    funcName: "中心补贴收取",
  },
  canteenSySet: {
    funcCode: "11func0004",
    funcName: "食堂补贴结算 0",
  },
  stallSySet: {
    funcCode: "011func0005",
    funcName: "档口补贴结算",
  },
  staffcanSet: {
    funcCode: "011func0006",
    funcName: "员工补贴发放",
  },
  armySet: {
    funcCode: "011func0007",
    funcName: "学员补贴发放",
  },

  //受理中心
  addCenter: {
    funcCode: "012func0001",
    funcName: "添加受理中心",
  },
  delCenter: {
    funcCode: "012func0002",
    funcName: "删除受理中心",
  },
  uptCenter: {
    funcCode: "012func0003",
    funcName: "修改受理中心",
  },
  qryCenter: {
    funcCode: "012func0004",
    funcName: "查询受理中心",
  },

  //食堂
  addCanteen: {
    funcCode: "012func0005",
    funcName: "添加食堂",
  },
  delCanteen: {
    funcCode: "012func0006",
    funcName: "删除食堂",
  },
  uptCanteen: {
    funcCode: "012func0007",
    funcName: "修改食堂",
  },
  qryCanteen: {
    funcCode: "012func0008",
    funcName: "查询食堂",
  },

  //档口
  addStall: {
    funcCode: "012func0009",
    funcName: "添加档口",
  },
  delStall: {
    funcCode: "012func0010",
    funcName: "删除档口",
  },
  uptStall: {
    funcCode: "012func0011",
    funcName: "修改档口",
  },
  qryStall: {
    funcCode: "012func0012",
    funcName: "查询档口",
  },

//部门中心
  addDepatr: {
    funcCode: "013func0001",
    funcName: "添加部门中心",
  },
  delDepatr: {
    funcCode: "013func0002",
    funcName: "删除部门中心",
  },
  uptDepatr: {
    funcCode: "013func0003",
    funcName: "修改部门中心",
  },
  qryDepatr: {
    funcCode: "013func0004",
    funcName: "查询部门中心",
  },

//科室
  addTechonical: {
    funcCode: "013func0005",
    funcName: "添加科室",
  },
  delTechonical: {
    funcCode: "013func0006",
    funcName: "删除科室",
  },
  uptTechonical: {
    funcCode: "013func0007",
    funcName: "修改科室",
  },
  qryTechonical: {
    funcCode: "013func0008",
    funcName: "查询科室",
  },

  //病区
  addInpatward: {
    funcCode: "013func0009",
    funcName: "添加病区",
  },
  delInpatward: {
    funcCode: "013func0010",
    funcName: "删除病区",
  },
  uptInpatward: {
    funcCode: "013func0011",
    funcName: "修改病区",
  },
  qryInpatward: {
    funcCode: "013func0012",
    funcName: "查询病区",
  },

  //修改密码
  changePws: {
    funcCode: "006func0005",
    funcName: "修改密码",
  },
  //重置密码
  resetAuthPwd: {
    funcCode: "006func0006",
    funcName: "重置密码",
  },

  //补贴配置
  addSubsidy: {
    funcCode: "014func0001",
    funcName: "添加补贴",
  },

  delSubsidy: {
    funcCode: "014func0002",
    funcName: "删除补贴",
  },

  uptSubsidy: {
    funcCode: "014func0003",
    funcName: "修改补贴",
  },

  qrySubsidy: {
    funcCode: "014func0004",
    funcName: "查询补贴",
  },

  qryAccount: {
    funcCode: "015func0001",
    funcName: "对账-结果查询",
  },
  qryHisAccount: {
    funcCode: "015func0002",
    funcName: "对账-统计",
  },
}


/**
 * 字符权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
export function checkFuncMap(value) {
  if (value && value instanceof Array && value.length > 0) {
    const permissions = store.getters && store.getters.permisonFun
    const permissionDatas = value
    // console.log('permissions',permissions)
    // console.log('permissionDatas',permissionDatas)

    const hasPermission = permissions.some(permission => {
      return permissionDatas.includes(permission)
    })
    if (!hasPermission) {
      return false
    }
    return true
  } else {
    console.error(`need roles! Like checkPermi="['system:user:add','system:user:edit']"`)
    return false
  }
}

export function Loading(me) {
  return me.$loading({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  // return loading
}


export {
  funcMap
}



// WEBPACK FOOTER //
// ./src/utils/function.js